import React from "react";
import './home-page.scss';
import axios from 'axios';

import HeaderComponent2 from "../../components/sections/header/new_header/header";
import FooterComponent from "../../components/sections/footer";
import IllustrationComponent from "../../components/sections/illustration";
import PrButtonComponent from "../../components/primitives/pr-button";
import PrCardComponent from "../../components/primitives/pr-card";
import PrTypengTitleComponent from "../../components/primitives/pr-typing-title";
import GrEmployeeComponent from "../../components/groups/gr-employee";
import SliderSectionComponent from "../../components/sections/slider-regular-entire";
import FSliderComponent from "../../components/sections/slider-fullscreen";
import GrIconsListComponent from "../../components/groups/gr-icons-list";

import data from "./data";

const API = 'https://www.powtoon.com/presentoons/count/';

export default class HomePage extends React.Component {

    screensDOM;

    constructor(props) {
        super(props);
        this.state = {
            counter: null,
            isLoading: false,
            error: null,
            cards: data.cards,
            employee: data.employee,
            slider: data.slider,
            sliderFS: data.sliderFS,
            icoArr: data.icoArr,
            forms: data.forms,
            sponsors: data.sponsors,
            activeCardI: null,
            sidebarVisible:false,
            animated: false
        }
        this.animationScroll = this.animationScrollController.bind(this);
        this.component = React.createRef();
        this.activeCardIndex = null;
        this.animatedBlock = false;
        this.title = null;
        this.titleAnimated = null;
        this.top = null;
    }

    positions(){
        this.top = this.component.current.querySelector('.top').getBoundingClientRect().height;
        this.title = this.component.current.querySelector('.animatedTitle').getBoundingClientRect().top;
        this.titleAnimated = this.component.current.querySelector('.top .wrapper').getBoundingClientRect().top;
    }

    componentDidMount() {
        const counterInterval = null;
        this.positions();
        this.scrollWrapper = document.querySelector('.home-page');
        this.screensDOM = this.component.current.querySelectorAll('.y-sync');
        this.scrollWrapper.addEventListener('scroll',this.animationScroll);

        this.resizeListener = () => {

            this.positions();

            if(window.innerWidth < 568){
                this.component.current.querySelector('.content-wrapper').classList.remove('scrolled');
                this.component.current.querySelector('.top .wrapper').classList.remove('animated');
            }
        }

        this.scrollListener = () => {
            if(window.innerWidth > 568){
                if(this.scrollWrapper.scrollTop > 0) {
                    this.component.current.querySelector('.content-wrapper').classList.add('scrolled');
                    this.component.current.style.setProperty('--el-height', `${(this.top) * -1}px`);
                    this.component.current.querySelector('.top .wrapper').classList.add('animated');
                    this.component.current.querySelector('.top .wrapper').style.setProperty('--el-position', `${this.title - this.titleAnimated}px`);
                }else{
                    this.component.current.querySelector('.decoration-1').classList.add('enter');
                    this.component.current.querySelector('.decoration-2').classList.add('enter');
                    this.component.current.querySelector('.content-wrapper').classList.remove('scrolled');
                    this.component.current.querySelector('.top .wrapper').classList.remove('animated');
                }
            }
        }

        this.getCounter();
        if(this.state.counter){
            counterInterval = setTimeout(()=>{
                this.getCounter();
            })
        } else{
            clearInterval(counterInterval);
        }

        window.addEventListener('resize', this.resizeListener);
        this.scrollWrapper.addEventListener('scroll', this.scrollListener);
    }

    getCounter() {
        const headers = {
            'Content-Type': 'text/plain'
        };
        this.setState({ isLoading: true });

        axios.get(API)
          .then(result => this.setState({
            counter: result.data.toLocaleString(),
            error: false
          }),{headers})
          .catch(error => this.setState({
            error: true
        }));

        if(this.state.counter === null){
            axios.get("https://cors-anywhere.herokuapp.com/" + API)
                .then(result => this.setState({
                counter: result.data.toLocaleString(),
                isLoading: false
                }),{headers})
                .catch(error => this.setState({
                error,
                isLoading: false
            }));
        }
    }

    animationScrollController() {
        for (let index = 0; index < this.screensDOM.length; index++) {
          if (
            !this.screensDOM[index].classList.contains('enter')
            && this.screensDOM[index].getBoundingClientRect().top - window.innerHeight < 40
            && this.screensDOM[index].getBoundingClientRect().bottom > 40
          ) {
            this.screensDOM[index].classList.add('enter');
          } else if (
            this.screensDOM[index].classList.contains('enter')
            &&
            !this.screensDOM[index].classList.contains('once')
            &&
            (
              (this.screensDOM[index].getBoundingClientRect().top - window.innerHeight > 40
              && this.screensDOM[index].getBoundingClientRect().bottom > 40)
            ||
              (this.screensDOM[index].getBoundingClientRect().top - window.innerHeight < 40
              && this.screensDOM[index].getBoundingClientRect().bottom < 40))
          ) {
            this.screensDOM[index].classList.remove('enter');
          }
        }
    }

    cardsState(event, index){
        if(index === this.state.activeCardI){
            this.setState({activeCardI: null});
        } else{
            this.setState({activeCardI: index});
        }
    }

    componentWillUnmount(){
        this.scrollWrapper.removeEventListener('scroll', this.scrollListener);
        window.removeEventListener('resize', this.resizeListener);
    }

    render(){
        return (
            <div className={`page-wrapper home-page`} ref={this.component}>
                <HeaderComponent2></HeaderComponent2>

                <main className={`content-wrapper ${this.state.animated ? 'scrolled' : ''}`}>

                    <section className="section-1">
                        <div className="top">
                            <p className="mobile-block text-style--t2">The Visual Communication Platform</p>
                            <div className="title extra-title--h1">
                                <p>Create unique</p>
                                <PrTypengTitleComponent position={this.state.titlePosition}></PrTypengTitleComponent>
                            </div>
                            <div className="wrap-top">
                                <p className="subtitle text-style--t2">One platform to create, manage, and distribute all of your videos and visual communications  </p>
                                <div className="wrap">
                                    <PrButtonComponent type="primary medium track" content="Start Now" link="/account/signup/" category="CTA" label="start_now" value="20025"></PrButtonComponent>
                                    {/* <PrButtonComponent type="secondary" content="Watch Why Powtoon" link="https://www.powtoon.com/account/signup/"></PrButtonComponent> */}
                                </div>
                                <p className="created extra-title--h7">Powtoons created <span>{this.state.counter ? this.state.counter : '91,154,700'}</span></p>
                            </div>
                        </div>
                    </section>
                    <div className="decoration decoration-1 y-sync enter"></div>
                    <div className="decoration decoration-2 y-sync enter"></div>

                    <section className="section-2">
                        <div className="illustration">
                            <IllustrationComponent></IllustrationComponent>
                            <div className="btn transition y-sync">
                                <PrButtonComponent type="primary medium dark-lighten track" content="Start Now" link="/account/signup/" category="CTA" label="start_now" value="20026"></PrButtonComponent>
                            </div>
                            <div className="background y-sync enter">
                                <link rel="preload" href="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1618908001/hp2021/backgrounds/200x120.png" as="image"/>
                                <img src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1618908001/hp2021/backgrounds/200x120.png" alt="#" title="#" className="bg_img" />
                            </div>
                        </div>
                    </section>

                    <section className="section-3">
                        <div className="content">

                            <div className="sponsors align y-sync">
                                <p className="title text-style--t2 transition y-sync">Join over 30 million people on Powtoon </p>
                                <div className="wrap transition y-sync">
                                    {this.state.sponsors.map((value, index) =>
                                        <img key={index} src={value} alt="#" />
                                    )}
                                </div>
                                <p className="created extra-title--h7 mobile-block">Powtoons created <span>{this.state.counter ? this.state.counter : '91,154,700'}</span></p>
                                <div className="btn mobile-block">
                                    <PrButtonComponent type="primary medium track" content="Start Now" link="/account/signup/" category="CTA" label="start_now" value="20026"></PrButtonComponent>
                                </div>
                            </div>

                            <div className="cards align y-sync">
                                    <p className="extra-title--h2 title transition y-sync">Everything you need in one place {this.props.setActiveCards}</p>
                                <div className="wrap">
                                    {this.state.cards.map((value, index) =>
                                        <div className="item y-sync" key={index} onClick={(event) =>  this.cardsState(event, index)}>
                                            <PrCardComponent data={value} type={`${index === 0 ? 'light' : 'dark'}`} state={index === this.state.activeCardI ? 'visible' : ''}></PrCardComponent>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="employees align y-sync">
                                <div className="decoration decoration-1"></div>
                                <div className="decoration decoration-2"></div>
                                <p className="extra-title--h2 title y-sync">Game-changing results for every team</p>
                                <div className="wrap">
                                    {this.state.employee.map((value, index) =>
                                        <GrEmployeeComponent key={index} data={value} firstActive={index === 0 ? 'firstActive' : ''} index={`${index}`}></GrEmployeeComponent>
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className="decoration decoration-3 y-sync"></div>
                    </section>

                    <section className="section-4 y-sync">
                        <div className="container">
                            <div className="column column-left">
                                <div className="slider-wrap">
                                    <FSliderComponent data={this.state.sliderFS}></FSliderComponent>
                                </div>
                                <div className="icons">
                                    <GrIconsListComponent icoArr={this.state.icoArr}></GrIconsListComponent>
                                </div>
                            </div>
                            <div className="column column-right">
                                <p className="title extra-title--h2 transition y-sync">The Visual Communication Platform for Enterprise</p>
                                <p className="subtitle text-style--t2 transition y-sync">Make it easy for your team to transform traditional materials into engaging videos and branded visual content at scale.</p>
                                <div className="row ">
                                    <PrButtonComponent type="primary medium track" link="https://www.powtoon.com/live-demo/" content="Talk to sales" category="CTA" label="talk_to_sales" value="20026"></PrButtonComponent>
                                    <PrButtonComponent type="secondary underline-none track" link="https://www.powtoon.com/enterprise/" content="Learn More" data-category="CTA" label="learn_more" value="20026"></PrButtonComponent>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="section-5">
                        <SliderSectionComponent slider={this.state.slider}></SliderSectionComponent>
                    </section>

                    <section className="section-6 y-sync">
                        {this.state.forms.map((value, index) => 
                            <img key={index} src={value} alt="#" className={`form form-${index}`}/>
                        )}
                        <div className="wrap">
                            <p className="title extra-title--h2 transition y-sync">Get started with Powtoon</p>
                            <p className="subtitle text-style--t3 transition y-sync">Simple creation. Professional results. No experience needed.</p>
                            <div className="btn transition y-sync">
                                <PrButtonComponent type="primary medium track" link="/account/signup/" category="CTA" label="start_now" value="20026" content="Get started"></PrButtonComponent>
                            </div>
                        </div>
                    </section>
                </main>

                <FooterComponent></FooterComponent>

            </div>
        );
    }
}
